import { OauthTokensAccesstoken } from './oauth-tokens-accesstoken.entity';

export const AUTH_ENTITIES = [OauthTokensAccesstoken];
